module.exports = __webpack_public_path__ + "static/3-388ad45224b16e0c1f61b5ed371434e2.jpg";